import React from 'react'
import Modal, { CloseButton } from 'components/common/modal/Modal'
import proCheckmark from 'images/pro-checkmark.svg'

interface BecomeAProModalProps {
  anchor: React.ReactElement
}

export const BecomeAProModal: React.FC<BecomeAProModalProps> = ({ anchor }) => {
  return (
    <Modal anchor={anchor}>
      <div className='become-a-pro-modal'>
        <div className='become-a-pro-content'>
          <img src={proCheckmark} className='become-a-pro-badge' />
          <h2 className='become-a-pro-heading'>Become a Pro!</h2>
          <div>
            <div>Want to reach more public sector customers? Stand out with Pro features:</div>
            <ul>
              <li>Reply to reviews</li>
              <li>Add custom content</li>
              <li>Gather more reviews</li>
            </ul>
            <div>Connect with our team to learn more.</div>
          </div>
        </div>
        <div className='become-a-pro-cta'>
          <CloseButton>
            <a
              className='button pro-rounded pro-closest-shadow pro-blue-500'
              href='https://hubs.la/Q01GhKqb0'
              target='_blank'
              rel='noreferrer'
            >
              Connect With Us
            </a>
          </CloseButton>
        </div>
      </div>
    </Modal>
  )
}
